import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import SingleRaw from '../tabs/registry/views/Single'
import { DRIVER_ROUTES } from '../routes-typed'
import { useDate } from '@/modules/drivers/stores/dateStore'
import { withRouter } from '@/app/navigation/withRouter'

const Single = withRouter(SingleRaw)

export const DriverTimesheetPage = ({ match, history }) => {
  const { params } = match
  const { companyId, driverId } = params
  const { getDateForView } = useDate()

  // Redirect to include default month if missing
  React.useEffect(() => {
    // Check if we're on the base route WITHOUT /month/ in the path
    const isOnBaseRoute = history.location.pathname.match(
      /\/timesheet\/driver\/\d+$/,
    )

    if (companyId && driverId && isOnBaseRoute) {
      // Use month from context (synced across all views)
      const defaultMonth = getDateForView('monthly')

      // Generate path with month
      const baseRoute = DRIVER_ROUTES.timesheet.buildPath({
        companyId: companyId,
        driverId: Number(driverId),
      })
      const newPath = `${baseRoute}/month/${defaultMonth}`
      history.replace(newPath)
    }
  }, [companyId, driverId, history])

  const singleElement = <Single companyId={companyId} driverId={driverId} />

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <Routes>
        <Route
          path="month/:month"
          element={singleElement}
        />
        <Route path="*" element={singleElement} />
      </Routes>
    </div>
  )
}
